// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import keys from "Keys";
import baseQueryWithReauth from "./requestInterceptor";

// Define a service using a base URL and expected endpoints

// const baseQuery = fetchBaseQuery({ baseUrl: keys.baseUrl });

export const globalControllingApi = createApi({
  reducerPath: "globalControllingApi",
  tagTypes: ["Control", "Sync"],
  refetchOnMountOrArgChange: true,
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getPendingGlobal: builder.query({
      query: ({ token, params }) => ({
        url: "controlling/global/pendingCount/" + params,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
      }),
      providesTags: ["Sync"],
    }),
    getSchedulesGlobal: builder.query({
      query: ({ token, params }) => ({
        url: "controlling/global" + params,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
      }),
      // Provides "Control" so mutations below can invalidate the cached
      // schedules list and trigger a refetch. Without this, the widget's
      // local updateSchFn splicing was the only thing keeping the visible
      // list in sync after Add/Edit/Delete/Sync — which silently broke on
      // navigation-away-and-back (stale cache served, then local splice
      // never re-ran).
      providesTags: ["Control"],
    }),
    addScheduleGlobal: builder.mutation({
      query: ({ token, body }) => ({
        url: "controlling/global/",
        method: "POST",
        body: body,
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
      }),
      // A new schedule changes both the list (Control) and the
      // pending-count badge (Sync — provided by getPendingGlobal).
      invalidatesTags: ["Control", "Sync"],
    }),
    syncScheduleGlobal: builder.mutation({
      query: ({ token, body }) => ({
        url: "controlling/global/syncShedules",
        method: "PUT",
        body: body,
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
      }),
      // Sync flips per-row pending/synced state (Control) and the global
      // pending-count badge (Sync).
      invalidatesTags: ["Control", "Sync"],
    }),
    editScheduleGlobal: builder.mutation({
      query: ({ token, name, body }) => ({
        url: "controlling/global/" + name,
        method: "PUT",
        body: body,
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
      }),
      // Edit changes a row's fields (Control) AND its pending/synced
      // status (Sync — previously this only invalidated Sync, leaving the
      // schedules list to be patched up by the widget's local splice).
      invalidatesTags: ["Control", "Sync"],
    }),
    deleteScheduleGlobal: builder.mutation({
      query: ({ token, id }) => ({
        url: "controlling/global/" + id,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
      }),
      // Delete removes a row (Control) and may also decrement the
      // pending-count badge (Sync) when the deleted row was pending.
      invalidatesTags: ["Control", "Sync"],
    }),
    broadcastGlobal: builder.mutation({
      query: ({ token, body }) => ({
        url: "devices/group/createSmartGroup",
        method: "POST",
        body: body,
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
      }),
    }),
  }),
});
export const {
  useGetSchedulesGlobalQuery,
  useEditScheduleGlobalMutation,
  useAddScheduleGlobalMutation,
  useDeleteScheduleGlobalMutation,
  useBroadcastGlobalMutation,
  useGetPendingGlobalQuery,
  useSyncScheduleGlobalMutation,
} = globalControllingApi;
